import { render, staticRenderFns } from "./DoubleHorizontalBar.vue?vue&type=template&id=08350177&"
import script from "./DoubleHorizontalBar.vue?vue&type=script&lang=js&"
export * from "./DoubleHorizontalBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports